import React, { useState, useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import { EmployerLayout } from '../Layout/EmployerLayout'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import TableHeader from '../Components/JobsTable/TableHeader'
import EmployerJobCard, { IEmployerJobCardProps } from '../Components/JobsTable/EmployerJobCard'
import MyPagination from '../Components/Pagination/MyPagination'
import classes from './JobsManager.module.css'
import { authAxios } from '../../../API/apiRequest'



const JobsManager: React.FC = ()=>{
     
    const [page, setPage] = useState(1)
    const [pages, setPages] = useState(1)
    const [total, setTotal] = useState(0)
    const [jobs, setJobs] = useState<IEmployerJobCardProps[]>([])
    
    const [loading, setLoading] = useState(true)
    const handlePageChange = async(event: React.ChangeEvent<unknown>, value: number)=>{
        setPage(value)
        try{
            setLoading(true)
            let result = await authAxios.get(`/employer/jobs?page=${value}`)
            setJobs(result.data.jobs)
        }catch(e){
            console.log(e)
        }
        setLoading(false)
    }

    useEffect(()=>{
        async function getJobs(page?: number){
            try{
                let result
                if(!page)
                    result = await authAxios.get('/employer/jobs')
                else
                    result = await authAxios.get(`/employer/jobs?page=${page}`)
                setJobs(result.data.jobs)
                setPages(result.data.lastPage)
                setTotal(result.data.totalJobs)

            }catch(e){
                console.log(e)
            }
            setLoading(false)
        }

        getJobs()
        
    },[])

    if(loading) return <JobManagerLoading />
    return(
        <EmployerLayout>
              <Row style={{boxSizing: 'border-box'}}>
                  <Col style={{
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center', 
                      marginTop: 20,
                      }}>
                    <div style={{width: 30, height: 30, borderRadius: 15, backgroundColor: '#6c757d', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <p style={{padding: 4, margin: 0, color: '#fff'}}>{total}</p>
                    </div>
                    <h3 className={classes.jobsText}>
                      الوظائف
                    </h3>
                  </Col>
              </Row>
              <TableHeader />
              {jobs.map(element=>(
              <EmployerJobCard
                title={element.title} 
                id={element.id}
                key={element.id} 
                status={element.status}
                applications={element.applications.toString()}
                />))}
                {total > 10 && <MyPagination 
                  page={page}
                  pages={pages}
                  handlePageChange={handlePageChange}
                />}
        </EmployerLayout>
    )
}


const LoadingEmployerJobCard: React.FC = ()=>{
    return(
        <Row style={{boxSizing: 'border-box'}} className={'mx-0'}>
        <div className='col p-0'style={{boxSizing: 'border-box'}}>
           <Skeleton direction='rtl' height={35} duration={0.8} />
        </div>
       </Row>
    )
}

const JobManagerLoading: React.FC = ()=>{

    return(
        <EmployerLayout>
        <SkeletonTheme baseColor="gray" highlightColor="#fff">
            <Row style={{boxSizing: 'border-box'}}>
                <Col>
                    <h3 className={classes.jobsText}>
                    الوظائف
                    </h3>
                </Col>
            </Row>
            <TableHeader />
            <LoadingEmployerJobCard />
            <LoadingEmployerJobCard />
            <LoadingEmployerJobCard />
            <LoadingEmployerJobCard />
        </SkeletonTheme>
        </EmployerLayout>
    )
}



export default JobsManager